/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The definition's own editable fields.
 * 
 * ``owner`` is not among them: moving a definition between companies would silently invalidate
 * every reference param configured on it. Duplicating to another company is a separate,
 * explicit operation that clears them.
 * @export
 * @interface WorkflowDefWrite
 */
export interface WorkflowDefWrite {
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefWrite
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefWrite
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowDefWrite
     */
    description?: string;
    /**
     * Is this workflow active? Inactive definitions are not used in new workflows.
     * @type {boolean}
     * @memberof WorkflowDefWrite
     */
    isActive?: boolean;
    /**
     * When enabled, events from the same batch that share a grouping field (e.g. site or equipment) will be linked. Configure the linking rule below.
     * @type {boolean}
     * @memberof WorkflowDefWrite
     */
    autoEventLinking?: boolean;
}

/**
 * Check if a given object implements the WorkflowDefWrite interface.
 */
export function instanceOfWorkflowDefWrite(value: object): value is WorkflowDefWrite {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function WorkflowDefWriteFromJSON(json: any): WorkflowDefWrite {
    return WorkflowDefWriteFromJSONTyped(json, false);
}

export function WorkflowDefWriteFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowDefWrite {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'autoEventLinking': json['auto_event_linking'] == null ? undefined : json['auto_event_linking'],
    };
}

export function WorkflowDefWriteToJSON(json: any): WorkflowDefWrite {
    return WorkflowDefWriteToJSONTyped(json, false);
}

export function WorkflowDefWriteToJSONTyped(value?: Omit<WorkflowDefWrite, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'is_active': value['isActive'],
        'auto_event_linking': value['autoEventLinking'],
    };
}

